import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'

/**
 * Custom hook to access authentication context
 * Provides user, session, loading state, and auth methods
 * 
 * Usage:
 * const { user, session, loading, login, signup, logout, profile, role } = useAuth()
 * 
 * @returns {Object} Authentication context
 * @throws {Error} If used outside AuthProvider
 */
export const useAuth = () => {
  const context = useContext(AuthContext)
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  
  return context
}

export default useAuth
